import { render } from "./TsogView.vue?vue&type=template&id=456249d4&scoped=true"
import script from "./TsogView.vue?vue&type=script&lang=js"
export * from "./TsogView.vue?vue&type=script&lang=js"

import "./TsogView.vue?vue&type=style&index=0&id=456249d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456249d4"]])

export default __exports__